import { Condition, TradeIn } from "Types/TradeIn";

export function hasYMMT(tradePending: Partial<TradeIn>) {
    if (tradePending.ymmt && tradePending.ymmt !== "") return true;
    return (
        tradePending.year !== "" && tradePending.make !== "" && tradePending.model !== "" && tradePending.trim !== ""
    );
}

export function hasTradeIn(tradePending: TradeIn): boolean {
    return !!tradePending.tp_tradein_report;
}

export function getTradeInEstimate(tradePending: TradeIn): number {
    let tradeInEstimate = 0;

    if (tradePending.tp_tradein_report && tradePending.condition) {
        switch (tradePending.condition) {
            case Condition.Low:
                tradeInEstimate = tradePending.tp_tradein_low as number;
                break;
            case Condition.Target:
                tradeInEstimate = tradePending.tp_tradein_target as number;
                break;
            case Condition.High:
                tradeInEstimate = tradePending.tp_tradein_high as number;
                break;
            default:
                break;
        }
    } else if (tradePending && tradePending.customer_estimate) {
        return tradePending.customer_estimate;
    }

    return tradeInEstimate ? tradeInEstimate : 0;
}
